import { setupListeners } from '@reduxjs/toolkit/query';
import { configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import storageSession from 'redux-persist/lib/storage/session';
import {
    FLUSH,
    PAUSE,
    PERSIST,
    persistReducer,
    PURGE,
    REGISTER,
    REHYDRATE,
} from 'redux-persist';
import { rtkQueryErrorLogger } from './features/middleware/rtkQueryErrorLogger';
import { REACT_APP_STORAGE_TYPE } from '../models/env';
import customWebReducer from './features/customWeb';
import { customProductApi } from './features/customProductApi';
import htmlElementSlice from './features/htmlElementsSlice';

const storageType =
    REACT_APP_STORAGE_TYPE === 'session' ? storageSession : storage;

const persistConfig = {
    key: 'CUSTOM_WEB',
    version: 1,
    storage: storageType,
};

const persistedReducer = persistReducer(persistConfig, customWebReducer);

const store = configureStore({
    reducer: {
        customWeb: persistedReducer,
        htmlElements: htmlElementSlice,
        [customProductApi.reducerPath]: customProductApi.reducer,
    },
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [
                    FLUSH,
                    REHYDRATE,
                    PAUSE,
                    PERSIST,
                    PURGE,
                    REGISTER,
                ],
            },
        }).concat(customProductApi.middleware, rtkQueryErrorLogger),
});

// infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch);
